// Tiny dotted-grid texture overlay built from a CSS radial-gradient.
// Drop into any positioning context to add a subtle grid behind content.

import { cn } from "@/lib/utils";

export interface DottedGridOverlayProps {
  /** Dot color (any CSS color). Encode the desired final alpha here. */
  color?: string;
  /** Grid spacing in CSS pixels (the gap between dots). */
  size?: number;
  className?: string;
}

export function DottedGridOverlay({
  color = "rgba(255, 255, 255, 0.12)",
  size = 16,
  className,
}: DottedGridOverlayProps) {
  return (
    <div
      aria-hidden
      style={{
        backgroundImage: `radial-gradient(${color} 1px, transparent 1px)`,
        backgroundSize: `${size}px ${size}px`,
      }}
      className={cn("pointer-events-none absolute inset-0", className)}
    />
  );
}
